export default function Art() {
  return (
    <table
      width="100%"
      height="100%"
      border="0"
      align="center"
      cellpadding="0"
      cellspacing="0"
    >
      <tr align="center" valign="bottom">
        <td height="30" colspan="2">
          <a class="1" href="/">
            return to main page
          </a>
        </td>
      </tr>
      <tr align="center" valign="middle">
        <td>
          <a href="/photos">
            <img
              src="/assets/i/phot.png"
              alt="photography"
              name="png"
              width="128"
              height="128"
              border="0"
              id="png"
            />{' '}
            <br />
            photography
          </a>
        </td>
        <td>
          <a href="/manip">
            <img
              src="/assets/i/manip.png"
              alt="manipulation"
              name="png"
              width="128"
              height="128"
              border="0"
              id="png"
            />
            <br />
            manipulation
          </a>
        </td>
      </tr>
      <tr align="center" valign="middle">
        <td colspan="2">
          <a href="/drawings">
            <img
              src="/assets/i/draw.png"
              alt="drawings"
              name="png"
              width="128"
              height="128"
              border="0"
              id="png"
            />
            <br />
            drawings
          </a>
        </td>
      </tr>
    </table>
  );
}
